import React from "react";
import { FlameIcon } from "lucide-react";
export function ScarcityBar() {
  return <div className="w-full rounded-2xl border border-red-200 bg-red-50 p-4" data-id="element-197" data-mp="2ywuh2n4qpycv">
      <div className="mb-2 flex items-center justify-between gap-2" data-id="element-198" data-mp="2yy5nyvthfm87">
        <div className="flex items-center gap-1.5 text-sm font-bold text-red-700" data-id="element-199" data-mp="2l4o0x11l7rdf">
          <FlameIcon className="h-4 w-4" data-id="element-200" data-mp="2q2puifwn3935" />
          ¡Cupos casi agotados!
        </div>
        <span className="text-sm font-extrabold text-red-700" data-id="element-201" data-mp="2b5p0g5qz721i">Quedan 7</span>
      </div>
      <div className="h-3 w-full overflow-hidden rounded-full bg-red-200" data-id="element-202" data-mp="2g63blwnvis3r">
        <div className="relative h-full rounded-full bg-red-500" style={{
        width: "91%"
      }} data-id="element-203" data-mp="226bqlbyxwbg9">
          <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent animate-shimmer" data-id="element-204" data-mp="274d9nwwd8arq" />
        </div>
      </div>
      <p className="mt-2 text-center text-xs font-medium text-red-700/80" data-id="element-205" data-mp="5ds2ao7k2aol">
        Faltan solo <strong data-id="element-206" data-mp="5bpb40uo2bia">7 cupos</strong> para cerrar el precio promocional de hoy.
      </p>
    </div>;
}